/* eslint-disable @typescript-eslint/no-empty-function */
import React, { ReactNode, createContext, useState } from 'react';

type AgreementModalContextType = {
    isOpen: boolean;
    setIsOpen: (isOpen: boolean) => void;
};

export const AgreementModalContext = createContext<AgreementModalContextType>({
    isOpen: false,
    setIsOpen: (isOpen: boolean) => undefined,
});

export const AgreementModalProvider: React.FC<{
    children: ReactNode;
}> = ({ children }): JSX.Element => {
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    const setIsOpen = (isOpen: boolean) => {
        setIsModalOpen(isOpen);
    };

    return (
        <AgreementModalContext.Provider value={{ isOpen: isModalOpen, setIsOpen: setIsOpen }}>
            {children}
        </AgreementModalContext.Provider>
    );
};
